import * as React from 'react'
import { MoonLoader } from 'react-spinners'
import { IServiceObject } from '../../types/index'
import ButtonFilled from '../ui/ButtonFilledOrange'
import Modal from '../ui/Modal'
import UIMessages from 'src/utils/ui-messages'
import { viewOptionTypes } from 'src/constants/service'

interface IServiceArchiveProps {
  service?: IServiceObject
  processing: boolean
  error: string
  onCancelClick: () => void
  onArchiveClick: (serviceId: string) => void
}

class ServiceArchiveModal extends React.Component<IServiceArchiveProps> {
  constructor(props: IServiceArchiveProps) {
    super(props)
  }

  public render() {
    const { service, processing, error, onCancelClick } = this.props

    const containerStyle = {
      width: 550,
      height: 300
    }

    if (!service) {
      return null
    }

    return (
      <Modal>
        <div className='fixed top-0 bottom-0 left-0 right-0 flex justify-center items-center'>
          <div className='flex flex-column justify-between bg-white p2' style={containerStyle}>
            <div className='flex flex-column'>
              <div className='h2'>Do you want to archive this service?</div>
              <div className='clearfix'>
                <div className='sm-col sm-col-2'>&nbsp;</div>
                <div className='sm-col sm-col-10'>
                  <div className='h3 pt1'>Service: {service.name}</div>
                  <div className='h6 pb3'>
                    {UIMessages.service.serviceDes}: {service.description}
                  </div>
                  <div className='h5 pt1'>
                    {UIMessages.service.membershipReq}: {service.isMembershipRequired ? 'Yes' : 'No'}
                  </div>
                  <div className='h5 pt1'>
                    {UIMessages.service.viewOption}:{' '}
                    {service.viewOption === viewOptionTypes.public
                      ? UIMessages.service.publicService
                      : UIMessages.service.privateService}
                  </div>
                  <div className='h5 pt1'>
                    {UIMessages.service.tripLimit}:{' '}
                    {service.tripLimit ? `${service.tripLimit} trips per ${service.tripLimitDuration}` : 'No Limit'}
                  </div>
                </div>
              </div>
            </div>

            {error && <div className='h5 font-orange mx-auto'>{error}</div>}
            <div className='mx-auto'>
              <MoonLoader sizeUnit={'px'} size={25} color={'#405264'} loading={processing} />
            </div>

            <div className='flex justify-end'>
              <div
                className='Cancel mr2 p1 font-light-grey rounded cursor--pointer bold user-select-none'
                onClick={onCancelClick}
              >
                Cancel
              </div>
              <ButtonFilled className='Submit user-select-none' onClick={this.handleArchiveClick}>
                Archive
              </ButtonFilled>
            </div>
          </div>
        </div>
      </Modal>
    )
  }

  private handleArchiveClick = () => {
    if (this.props.service) {
      this.props.onArchiveClick(this.props.service.id)
    }
  }
}

export default ServiceArchiveModal



// WEBPACK FOOTER //
// ./src/components/services/ServiceArchiveModal.tsx